import React from "react";
import Container from "../Container";
import StatisticsBox from "./StatisticsBox";
import PrimaryButton from "../PrimaryButton";
const Statistics = () => {
  return (
    <>
      <section className="bg-primary">
        <Container>
          <div className="text-center text-white ">
            <h2 className="text-2xl">اهدافنا</h2>
            <h3>تعرف على اهداف الجمعية القادمة</h3>
          </div>
          <div>
            <div className="flex flex-wrap justify-center gap-12 mt-10 md:mt-14">
              <StatisticsBox
                svg={
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor"
                    width="3em"
                    height="3em"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M8.25 6.75a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0ZM15.75 9.75a3 3 0 1 1 6 0 3 3 0 0 1-6 0ZM2.25 9.75a3 3 0 1 1 6 0 3 3 0 0 1-6 0ZM6.31 15.117A6.745 6.745 0 0 1 12 12a6.745 6.745 0 0 1 6.709 7.498.75.75 0 0 1-.372.568A12.696 12.696 0 0 1 12 21.75c-2.305 0-4.47-.612-6.337-1.684a.75.75 0 0 1-.372-.568 6.787 6.787 0 0 1 1.019-4.38Z"
                      clipRule="evenodd"
                    />
                    <path d="M5.082 14.254a8.287 8.287 0 0 0-1.308 5.135 9.687 9.687 0 0 1-1.764-.44l-.115-.04a.563.563 0 0 1-.373-.487l-.01-.121a3.75 3.75 0 0 1 3.57-4.047ZM20.226 19.389a8.287 8.287 0 0 0-1.308-5.135 3.75 3.75 0 0 1 3.57 4.047l-.01.121a.563.563 0 0 1-.373.486l-.115.04c-.567.2-1.156.349-1.764.441Z" />
                  </svg>
                }
                title={"المستفيدين"}
                desc={"مستفيد"}
                count={""}
                className={
                  "min-w-60 flex items-center justify-center flex-col text-white"
                }
              ></StatisticsBox>
              <StatisticsBox
                svg={
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="3em"
                    height="3em"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fill="currentColor"
                      d="M18.405 4.799c-.111-.44-.655-.799-1.21-.799h-6.814c-.554 0-1.33-.318-1.722-.707l-.596-.588C7.671 2.316 6.896 2 6.342 2H3.087c-.555 0-1.059.447-1.12.994L1.675 6h16.931zM19.412 7H.588a.58.58 0 0 0-.577.635l.923 9.669A.77.77 0 0 0 1.7 18h16.6a.77.77 0 0 0 .766-.696l.923-9.669A.58.58 0 0 0 19.412 7"
                    />
                  </svg>
                }
                title={"المساعدات"}
                desc={"مساعدة"}
                count={""}
                className={
                  "min-w-60 flex items-center justify-center flex-col text-white"
                }
              ></StatisticsBox>

              <StatisticsBox
                svg={
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="1.88em"
                    height="3em"
                    viewBox="0 0 320 512"
                  >
                    <path
                      fill="currentColor"
                      d="M112 48a48 48 0 1 1 96 0a48 48 0 1 1-96 0m40 304v128c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9l-28.6 47.6c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l58.3 97c9.1 15.1 4.2 34.8-10.9 43.9s-34.8 4.2-43.9-10.9L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352z"
                    />
                  </svg>
                }
                title={"المتطوعين"}
                desc={"متطوع"}
                count={""}
                className={
                  "min-w-60 flex items-center justify-center flex-col text-white"
                }
              ></StatisticsBox>
            </div>
          </div>
          <div className="flex justify-center gap-4 mt-4">
          </div>
        </Container>
      </section>
    </>
  );
};

export default Statistics;
